module.exports = __webpack_public_path__ + "static/floral-1-7679dd51a879826b4061cc8f89a0cec6.jpg";